<template>
  <div :class="['wrapper-selection', { 'mb-10': showMaterialControl }]" v-if="showControls()">
    <el-col class="material-controls">
      <div class="left">
        <p class="rank">{{ rankLabel }}</p>
        <p class="lesson">{{ lessonLabel }}</p>
      </div>

      <div class="right">
        <el-button
          v-if="showChangeMaterial"
          @click="setShowMaterialControl(!showMaterialControl)"
          :disabled="isVideoScreenLayout"
        >
          {{ $t('materialControls.change') }}<img :src="showIcon" />
        </el-button>

        <el-button
          v-if="showWordbookButton"
          @click="setShowVocabularyBook(!showVocabularyBook)"
          :disabled="isVideoScreenLayout"
        >
          {{ $t('materialControls.myWordBook') }}
        </el-button>
      </div>
    </el-col>

    <el-col
      :class="[
        'controls-wrapper',
        { 'p-0': !showMaterialControl },
        { 'border-none': !showMaterialControl }
      ]"
    >
      <el-col v-if="showMaterialControl && showNextPrevControls()" class="controls">
        <div>
          <el-button
            class="btn previous-lesson"
            @click="previousLesson()"
            :disabled="isAssessmentStudent || !isVideoReady"
          >
            <i class="el-icon-arrow-left"></i>
            {{ $t('materialControls.previous') }}
          </el-button>
        </div>
        <div class="text-center">{{ $t('materialControls.change') }}</div>
        <div class="text-right">
          <el-button
            class="btn next-lesson"
            @click="nextLesson()"
            :disabled="isAssessmentStudent || !isVideoReady"
          >
            {{ $t('materialControls.next') }}
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </el-col>

      <MaterialSelection />
    </el-col>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

import MaterialSelection from '@/components/Lesson/Material/MaterialSelection';
import materialMixin from '@/mixins/material';

export default {
  components: {
    MaterialSelection
  },
  mixins: [materialMixin],
  computed: {
    ...mapState('material', [
      'showMaterialControl',
      'showVocabularyBook',
      'articleTitle',
      'currentRanks',
      'currentLessons'
    ]),
    ...mapState('layout', ['layoutColor', 'isMobileSize']),
    ...mapState('video', ['showVideo', 'isVideoReady']),
    ...mapGetters([
      'isBizmatesLesson',
      'isDiscoveryLesson',
      'isAssistLesson',
      'nonActualLesson',
      'isOtherLesson',
      'isZipanService'
    ]),
    ...mapGetters('material', ['articleLevels']),
    ...mapGetters('layout', ['isVideoScreenLayout']),
    ...mapGetters(['isTrainer', 'isStudent', 'isAssessmentLesson', 'isCorpLesson']),
    ...mapGetters('userOtherSetting', ['isTaiwanCountryId']),
    showIcon() {
      if (this.showMaterialControl) {
        return require(`@/assets/img/show_${this.layoutColor}.png`);
      }
      return require(`@/assets/img/hide_${this.layoutColor}.png`);
    },
    rankLabel() {
      const discoveryLevel = this.articleLevels
        ? `${this.$t('discoveryMaterial.level')} ${this.articleLevels}`
        : '';
      return this.isDiscoveryLesson ? discoveryLevel : this.rankDescription;
    },
    lessonLabel() {
      return this.isDiscoveryLesson ? this.articleTitle : this.lessonDescription;
    },
    showChangeMaterial() {
      return !this.isAssessmentStudent && !this.isDiscoveryLesson;
    },
    isAssessmentStudent() {
      return !this.isTrainer && this.isAssessmentLesson;
    },
    rankDescription() {
      if (!this.currentRanks || typeof(this.currentRanks.lv) === 'undefined') {
        return;
      }
      return this.formatRankLabel(this.currentRanks.lv, this.currentRanks.rt, this.currentRanks.rv);
    },
    lessonDescription() {
      if ((!this.currentLessons || !this.currentLessons.ln) && !this.isAssessmentLesson) {
        return;
      }
      return this.formatLessonLabel(this.currentLessons);
    },
    showWordbookButton() {
      return (
        this.isStudent &&
        !this.nonActualLesson &&
        !this.isAssessmentLesson &&
        !this.isCorpLesson &&
        !this.isZipanService &&
        !this.isTaiwanCountryId
      );
    }
  },
  watch: {
    isVideoScreenLayout() {
      this.setShowMaterialControl(false);
    }
  },
  methods: {
    ...mapMutations('material', [
      'setShowMaterialControl',
      'setShowVocabularyBook',
      'nextLesson',
      'previousLesson'
    ]),
    showControls() {
      return !this.isAssistLesson;
    },
    showNextPrevControls() {
      return this.isMobileSize ? false : !this.isAssessmentStudent || this.isBizmatesLesson;
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/material_controls.css"></style>
